import ConditionType from './ConditionType'

const LessThanOrEqualsCondition: ConditionType = {
  value: 'less than or equals',
  label: 'Less Than or Equal To',
  hasRHS: true,
}

export default LessThanOrEqualsCondition
